module.exports = __webpack_public_path__ + "img/Indio_Logo_Simple.750d3268.png";